import CameraDimensionResolver from '@/composables/charts/influx-charts/dimension-resolvers/influx/CameraDimensionResolver'

export class IncidentCameraDimensionResolver extends CameraDimensionResolver {
  async doesTagKeyMatch(tag: string): Promise<boolean> {
    if (tag.includes('camera')) return true
    return false
  }
}
